import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { EventsCalendar } from './pages/EventsCalendar';
import { Gallery } from './pages/Gallery';
import { AfterHours } from './pages/AfterHours';
import { BottleService } from './pages/BottleService';
import { Contact } from './pages/Contact';
import { CorporateEvents } from './pages/CorporateEvents';
import { Daytime } from './pages/Daytime';
import { Nightlife } from './pages/Nightlife';
import { VipHosts } from './pages/VipHosts';
import { BookRoom } from './pages/BookRoom';
import { Cart } from './pages/Cart';
import { BookNow } from './pages/BookNow';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/events" element={<EventsCalendar data-id="element-5" />} data-id="element-4" />
        <Route path="/gallery" element={<Gallery data-id="element-7" />} data-id="element-6" />
        <Route path="/after-hours" element={<AfterHours data-id="element-9" />} data-id="element-8" />
        <Route path="/bottle-service" element={<BottleService data-id="element-11" />} data-id="element-10" />
        <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
        <Route path="/corporate-events" element={<CorporateEvents data-id="element-15" />} data-id="element-14" />
        <Route path="/daytime" element={<Daytime data-id="element-17" />} data-id="element-16" />
        <Route path="/nightlife" element={<Nightlife data-id="element-19" />} data-id="element-18" />
        <Route path="/vip-hosts" element={<VipHosts data-id="element-21" />} data-id="element-20" />
        <Route path="/book-room" element={<BookRoom data-id="element-23" />} data-id="element-22" />
        <Route path="/cart" element={<Cart data-id="element-25" />} data-id="element-24" />
        <Route path="/book-now" element={<BookNow data-id="element-27" />} data-id="element-26" />
      </Routes>
    </Router>;
}